import { Tag, Space, Button, Tooltip, Typography } from "antd";
import { EditOutlined, DeleteOutlined, EyeOutlined } from "@ant-design/icons";

const buildColumns = ({ onView, onEdit, onDelete, page = 1, limit = 20 }) => [
  {
    title: "Sr. No",
    key: "sno",
    width: 52,
    align: "center",
    render: (_, __, index) => (
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {(page - 1) * limit + index + 1}
      </Typography.Text>
    ),
  },
  {
    title: "Step",
    dataIndex: "step",
    key: "step",
    width: 100,
    align: "center",
    sorter: (a, b) => Number(a.step || 0) - Number(b.step || 0),
    defaultSortOrder: "ascend",
    render: (s) => <Tag color="blue">{s}</Tag>,
  },
  {
    title: "Short Text",
    dataIndex: "queCode",
    key: "queCode",
    width: 200,
    ellipsis: true,
    sorter: (a, b) => (a.queCode || "").localeCompare(b.queCode || ""),
    render: (k) => <Typography.Text code>{k}</Typography.Text>,
  },
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    width: 360,
    ellipsis: true,
    render: (t) => (
      <Tooltip title={t}>
        <span style={{ fontWeight: 500 }}>{t || "Untitled"}</span>
      </Tooltip>
    ),
  },
  {
    title: "Type",
    dataIndex: "optionType",
    key: "optionType",
    width: 110,
    align: "center",
    render: (t) =>
      t === "multiple" ? (
        <Tag color="purple">Multiple</Tag>
      ) : (
        <Tag color="geekblue">Single</Tag>
      ),
  },
  {
    title: "Store",
    key: "storeLabel",
    width: 130,
    render: (_, record) => {
      const label = record.storeLabel || record.store_label || "";
      const hash  = record.storeHash  || record.store_hash  || "";
      return (
        <Space size={4} direction="vertical" style={{ lineHeight: 1.2 }}>
          {label ? (
            <Tag color="geekblue" style={{ marginRight: 0 }}>{label}</Tag>
          ) : (
            <Typography.Text type="secondary" style={{ fontSize: 11 }}>—</Typography.Text>
          )}
          <Tooltip title={hash}>
            <Typography.Text code style={{ fontSize: 11 }}>{hash || "—"}</Typography.Text>
          </Tooltip>
        </Space>
      );
    },
  },
  {
    title: "Actions",
    key: "actions",
    width: 140,
    fixed: "right",
    align: "center",
    render: (_, record) => (
      <Space onClick={(e) => e.stopPropagation()}>
        <Tooltip title="Edit">
          <Button size="small" icon={<EditOutlined />} onClick={() => onEdit?.(record)} />
        </Tooltip>
        <Tooltip title="View">
          <Button size="small" icon={<EyeOutlined />} onClick={() => onView?.(record)} />
        </Tooltip>    
        <Tooltip title="Delete">
          <Button
            size="small"
            danger
            icon={<DeleteOutlined />}
            onClick={() => onDelete?.(record)}
          />
        </Tooltip>
      </Space>
    ),
  },
];

export default buildColumns;
